<div class="container-data">
  <div class="edit-view">
    <div class="fc-toolbar">
      <button nz-button nzShape="circle" nzType="primary" nz-tooltip nzTooltipTitle="Adicionar"
        (click)="novo()" [disabled]="disableAdd">
        <span nz-icon nzType="plus"></span>
      </button>
      <nz-divider nzType="vertical"></nz-divider>
      <button nz-button nzShape="circle" nzType="primary" nz-tooltip nzTooltipTitle="Salvar"
        (click)="salvar()" [disabled]="!disableAdd && !visibleParam">
        <span nz-icon nzType="check"></span>
      </button>
      <button nz-button nzShape="circle" nz-tooltip nzTooltipTitle="Cancelar"
        (click)="cancelEdit()" [disabled]="!disableAdd && !visibleParam">
        <span nz-icon nzType="close"></span>
      </button>
    </div>

    <div class="grid-view">
      <nz-table #filterTable [nzData]="filter" nzSize="small" [nzFrontPagination]="false" [nzShowPagination]="false">
        <thead>
          <tr>
            <th>Tipo</th>
            <th>Descrição</th>
            <th>Nome</th>
            <th>Instância Origem</th>
            <th>Descrição da Instância</th>
            <th nzWidth="70px">Ação</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let item of filterTable.data; let index = index" (click)="editItem(item, index)"
            class="fc-row">
            <td>{{ getTypeDescription(item.tipo) }}</td>
            <td>{{ item.desc }}</td>
            <td>{{ item.nome }}</td>
            <td>{{ item.entityName }}</td>
            <td>{{ item.entityDesc }}</td>
            <td>
              <button nz-button nzType="text" nzShape="circle" nzDanger (click)="deleteItem($event, item)">
                <span nz-icon nzType="delete"></span>
              </button>
            </td>
          </tr>
        </tbody>
      </nz-table>
    </div>
  </div>

  <form #itemForm="ngForm" *ngIf="visibleParam">
    <div class="detail-item">
      <div class="detail-item-tipo-box-main">
        <div class="detail-item-tipo-box">
          <div class="detail-item-tipo">
            <nz-form-item class="fc-field">
              <nz-form-label nzRequired>Tipo</nz-form-label>
              <nz-form-control>
                <nz-select [(ngModel)]="parameterType" required name="pt" nzPlaceHolder="Tipo">
                  <nz-option *ngFor="let item of types" [nzValue]="item.type" [nzLabel]="item.description"></nz-option>
                </nz-select>
              </nz-form-control>
            </nz-form-item>
            <nz-form-item class="fc-field" *ngIf="parameterType=='R'">
              <nz-form-label [nzRequired]="parameterType=='R'">Entidade</nz-form-label>
              <nz-form-control>
                <nz-select [(ngModel)]="entityOrigem" [required]="parameterType=='R'"
                  (ngModelChange)="onSelectEntity()" name="et" nzShowSearch nzPlaceHolder="Entidade">
                  <nz-option *ngFor="let item of entityOrigemList" [nzValue]="item.entityName"
                    [nzLabel]="item.entityName + ' - ' + item.entityDesc"></nz-option>
                </nz-select>
              </nz-form-control>
            </nz-form-item>
          </div>
          <nz-form-item class="fc-field">
            <nz-form-label nzRequired>Nome</nz-form-label>
            <nz-form-control>
              <nz-input-group [nzSuffix]="clearNameTpl">
                <input nz-input type="text" pattern="[A-Z0-9]+"
                  (ngModelChange)="parameterName = $event.toUpperCase()" [ngModel]="parameterName"
                  [disabled]="editingItem" required name="pn">
              </nz-input-group>
              <ng-template #clearNameTpl>
                <span nz-icon nzType="close-circle" nzTheme="fill" class="fc-clear"
                  *ngIf="parameterName && parameterType!='R'" (click)="parameterName=''"></span>
              </ng-template>
            </nz-form-control>
          </nz-form-item>
          <nz-form-item class="fc-field">
            <nz-form-label nzRequired>Descrição</nz-form-label>
            <nz-form-control>
              <nz-input-group [nzSuffix]="clearDescTpl">
                <input nz-input type="text" [(ngModel)]="parameterDesc" required name="pd">
              </nz-input-group>
              <ng-template #clearDescTpl>
                <span nz-icon nzType="close-circle" nzTheme="fill" class="fc-clear" *ngIf="parameterDesc"
                  (click)="parameterDesc=''"></span>
              </ng-template>
            </nz-form-control>
          </nz-form-item>
        </div>
        <div class="detail-item-tipo-box-listoption" *ngIf="parameterType=='L'">
          <div class="list-option-main">
            <nz-form-item class="fc-field">
              <nz-form-label>Lista de Opções (Valor=Descrição)</nz-form-label>
              <nz-form-control>
                <textarea nz-input placeholder="Lista de Opções (Valor=Descrição)" aria-label="ListaOpcoes"
                  class="fc-list-textarea" [(ngModel)]="listOptionStr" name="lo"></textarea>
              </nz-form-control>
            </nz-form-item>
          </div>
        </div>
      </div>
    </div>
  </form>
  <actions-buttons [buttonList]="buttonList"></actions-buttons>
</div>
